// Ordenação client-side do CustomGrid (mesmo critério da tela), reaproveitada
// na exportação quando o backend não ordena (ex.: clientes).
// Datas → cronológico; números → numérico; demais → localeCompare. Nulos primeiro
// no asc. Estável: linhas sem o campo mantêm a ordem recebida.
export const compareGridValues = (va, vb, dir) => {
  if (va == null && vb == null) return 0;
  if (va == null) return dir === "asc" ? -1 : 1;
  if (vb == null) return dir === "asc" ? 1 : -1;

  const da = new Date(va);
  const db = new Date(vb);
  if (!isNaN(da) && !isNaN(db)) {
    return dir === "asc" ? da - db : db - da;
  }

  if (typeof va === "number" && typeof vb === "number") {
    return dir === "asc" ? va - vb : vb - va;
  }

  return dir === "asc"
    ? String(va).localeCompare(String(vb))
    : String(vb).localeCompare(String(va));
};

export const sortGridRows = (rows, field, dir) => {
  const list = [...(rows || [])];
  if (!field || !dir) return list;
  return list.sort((a, b) => compareGridValues(a?.[field], b?.[field], dir));
};
